module.exports = __webpack_public_path__ + "img/DE01108.e103a0b0.png";